<template>
  <span v-if="values && values.filter(i => i.active).length > 0">
    <div
      v-for="(item, index) in values.filter(i => i.active)"
      :key="index">
      <span
        class="licence"
        :class="{ 'full': !item.authorizations.find(a => !a.active) }">
        {{ item.name }}
      </span>
    </div>
    <span v-if="values.length < values.length">
      ...
    </span>
  </span>
  <span v-else>
    {{ $t('serverModel.components.field.displayLicences.noSchema','No {schemaName}', { schemaName : schema.name}) }}
  </span>
</template>

<script>
import { navigationPropertyListMixin } from 'schema-view/src/mixins/navigationPropertyListMixin'

export default {
  mixins: [navigationPropertyListMixin]
}
</script>

<style lang="scss" scoped>
  .licence {
    color: #AED581;
    &.full {
      color: #49ba32;
    }
  }
</style>
